





import User from "@/models/user";
import UsersAPI from "@/services/users";
import { LayoutModule } from "@/store/layout";
import { UserModule } from "@/store/user";
import { Component, Vue } from "vue-property-decorator";
import UserForm from "./Components/UserForm.vue";

@Component({ components: { UserForm } })
export default class EditUser extends Vue {
  user: User | null = null;
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getUser();
  }

  get isAdmin(): boolean {
    return UserModule.getCurrentUser.role.indexOf("admin") !== -1;
  }

  async getUser(): Promise<void> {
    try {
      const r = await UsersAPI.getUser(this.$route.params.id);
      console.log(r);

      this.user = r;
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  cancel(): void {
    this.isAdmin
      ? this.$router.push({ name: "users" })
      : this.$router.push({ name: "home" });
  }

  async save(user: User): Promise<void> {
    try {
      await UsersAPI.updateUser(user);

      if (this.isAdmin) {
        const r = await UsersAPI.updateRole(user);
        console.log(r);
      }

      LayoutModule.setAlerts({
        text: this.$t("users.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
  }
}
